import React from "react";

/**
 * CC Recipients Display Component
 * Shows CC recipients as comma-separated values (Name, Employee ID)
 * Matches the format of "To" employee display
 *
 * @param {Array|String} ccRecipients - Array of CC recipient objects or JSON string
 */
const CCRecipients = ({ ccRecipients }) => {
  // Handle empty or invalid CC list
  if (!ccRecipients || ccRecipients.length === 0) {
    return <span className="text-muted" style={{ fontSize: "14px" }}>—</span>;
  }

  // Parse CC recipients if it's a string (from backend)
  let recipients = ccRecipients;
  if (typeof ccRecipients === "string") {
    try {
      recipients = JSON.parse(ccRecipients);
    } catch (e) {
      // If it's just a comma-separated string, display as-is
      return <span style={{ fontSize: "14px" }}>{ccRecipients}</span>;
    }
  }

  // Ensure it's an array
  if (!Array.isArray(recipients)) {
    recipients = [recipients];
  }

  // Format each recipient as "Name, EmployeeID"
  const formattedRecipients = recipients.map((recipient) => {
    if (typeof recipient === 'string') {
      return recipient;
    }

    const name = recipient.name || `Employee ${recipient.employee_id}`;
    const employeeId = recipient.employee_number || recipient.employee_id;

    return employeeId ? `${name}, ${employeeId}` : name;
  });

  // Join all recipients with semicolons for better readability
  const displayText = formattedRecipients.join("; ");

  return (
    <span style={{ fontSize: "14px", color: "#212529" }}>
      {displayText}
    </span>
  );
};

export default CCRecipients;
